var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasValidQRCode)?_c('div',{staticClass:"qrcode-wrapper",class:{
    'fullscreen': _vm.isFullScreen,
    [`position-${_vm.posicaoEnquete}`]: true
  }},[_c('div',{staticClass:"qrcode-container"},[_c('BaseQRCode',{staticClass:"qrcode-bg",attrs:{"preserveAspectRatio":"none"}}),_c('img',{staticClass:"qrcode-image",attrs:{"src":_vm.item.enquete_qr_code.url,"alt":_vm.qrCodeAltText},on:{"error":_vm.onQRCodeError}})],1),_c('div',{staticClass:"participe-label"},[_c('ParticipeQRCode',{staticClass:"participe-bg",attrs:{"preserveAspectRatio":"none"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }